import React from 'react';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { formatTimestampDate } from 'Utils/date/dateUtils';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
type Props = {
  className?: string;
  dates: {
    endDate: Timestamp;
    startDate: Timestamp;
  };
};
export const AccommodationRoomDates = ({ className, dates }: Props) => {
  if (!dates?.endDate || !dates?.startDate) {
    return null;
  }

  return (
    <TemplateString
      className={classnames(
        'inline-block rounded-pill bg-black px-10 py-5 text-16 font-bold text-white',
        className,
      )}
      template={t('booking.priceDetails.packagePrice.departureDateFormat')}
      values={{
        arrivalDate: String(
          formatTimestampDate(dates.startDate, t('booking.common.condensedDateFormat')),
        ),
        departureDate: String(
          formatTimestampDate(dates.endDate, t('booking.common.condensedDateFormat')),
        ),
      }}
    />
  );
};
